'use strict';

import type { IndPharmacy } from '../../Entities/Ind/IndPharmacy';
import { EntityCollection } from '../EntityCollection';

export class IndPharmacyCollection extends EntityCollection<IndPharmacy> {}
